import React, { Fragment, useEffect, useState } from 'react';
import { Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import Loader from '../../../components/Loader/Loader';
import { formikAddRole, portalLayoutOption } from '../Constant';
import { useFormik } from 'formik';
import { failed, success } from '../../../utils/Tostify';
import { updateRole } from '../../../api/User';
import { useDispatch, useSelector } from 'react-redux';
import TextInput from '../../../components/InputFields/TextInput';

const EditRole = ({ setShowModal, roleData, refetch }) => {
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const formik = useFormik({
        ...formikAddRole,
        onSubmit: async (values) => {
            let res;
            try {
                setIsLoading(true);
                res = await updateRole({ values, dispatch, token });
                if (res?.status == "SUCCESS") {
                    setIsLoading(false);
                    success(res?.message);
                    formik.resetForm();
                    setShowModal(false);
                    refetch();
                } else {
                    setIsLoading(false);
                    failed(res?.message);
                }
            } catch (error) {
                setIsLoading(false);
                failed(res?.message);
            }
        }
    });

    useEffect(() => {
        formik.setFieldValue("roleName", roleData?.roleName);
        formik.setFieldValue("portalLayout", roleData?.portalLayout);
        formik?.setFieldValue("roleId", roleData?._id);
        formik?.setFieldValue("description", roleData?.description);
    }, [roleData]);

    useEffect(() => {
        if (setShowModal) {
          const modalBody = document.querySelector('.assign_modal_body');
          if (modalBody) {
            modalBody.scrollTop = 0;
          }
        }
      }, [setShowModal]);

    return (
        <Fragment>
            <Modal isOpen={setShowModal} toggle={setShowModal} size="xl">
                <ModalHeader toggle={setShowModal} className="assign_blk p-0 mb-2">Edit Role</ModalHeader>
                <Form onSubmit={formik.handleSubmit}>
                    <ModalBody>
                    {isLoading ? <Loader /> : null}
                        <div className="organization_form_block organization_blk p-0 m-0 modal_change_color">
                            <div className="modal_change_color p-3">
                                <div className="forms_block">
                                        <div className="first_block">
                                            <Row>
                                                <Col lg={6} className="location_block">
                                                    <TextInput
                                                        keyField={"roleName"}
                                                        formik={formik}
                                                        label="Role Name"
                                                        type="text"
                                                        placeholder="Role Name"
                                                        value={formik.values.roleName}
                                                        onChange={(e) => formik.setFieldValue("roleName", e.target.value)}
                                                        autoFocus={true}
                                                    />
                                                </Col>
                                                <Col lg={6} className="location_block">
                                                    <TextInput
                                                        keyField={"portalLayout"}
                                                        formik={formik}
                                                        label="Portal Layout"
                                                        placeholder={"Portal Layout"}
                                                        options={portalLayoutOption}
                                                        type="select"
                                                        value={formik.values.portalLayout}
                                                        onChange={(e) => formik.setFieldValue("portalLayout", e.target.value)}
                                                    />
                                                </Col>
                                                <Col lg={12} className="location_block">
                                                    <TextInput
                                                        keyField={"description"}
                                                        formik={formik}
                                                        label="Description"
                                                        type="textarea"
                                                        required={false}
                                                        placeholder="Role Description"
                                                        value={formik.values.description}
                                                        onChange={(e) => formik.setFieldValue("description", e.target.value)}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <div className="d-flex justify-content-between">
                            <button className="save_btn" onClick={() => setShowModal(false)}>Cancel</button>
                            <div className="d-flex gap-3">
                                <button className="save_btn" type="submit"> Save</button>
                            </div>
                        </div>
                    </ModalFooter>
                </Form>
            </Modal>
        </Fragment>
    );
};

export default EditRole;
